module.exports = __webpack_public_path__ + "img/首页1.1d908024.jpg";